import * as Yup from 'yup';
import { validateAreaCode } from '../../utils/validateAreaCode';

export const faqsSchema = Yup.object().shape({
    first_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    last_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    phone: Yup.string()
        .min(15, 'Invalid phone number')
        .required('Required')
        .test('no-identical-area-code', 'Invalid phone number', validateAreaCode),
    email: Yup.string().email('Invalid email').required('Required'),
    location: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
});
